import { Box, Button, Typography, CircularProgress } from "@material-ui/core";
import { RouteComponentProps } from "@reach/router";
import { Link } from "gatsby";
import React from "react";
import useActivatedPodHistory from "../../../../../hooks/use-activated-pod-history";
import ActivationHeading from "../../../components/ActivationHeading";
import ActivationLayout from "../../../components/Layout";
import PodProductCard from "../../../components/PodProductCard";
import { usePodDetails } from "../../../hooks/usePodDetails";
import useRequireAuthenticated from "../../../hooks/useRequireAuthenticated";
import useRequireUnlockAllowed from "../../../hooks/useRequireUnlockAllowed";
import useProductQuery from "../../../../../hooks/use-product-query";
import ProductDetailsOilTable from "../../../../../containers/shop/ProductDetails/components/Overview/OilTable";

type Props = RouteComponentProps<{ podKeyOrSerialNumber: string }>;

export default function ActivationStep5UnlockComplete({
  podKeyOrSerialNumber
}: Props) {
  useRequireAuthenticated();
  const isUnlockAllowed = useRequireUnlockAllowed();

  // Pod details
  const [podDetails] = usePodDetails(podKeyOrSerialNumber);
  const { data: podProduct, isLoading: isLoadingPodProduct } = useProductQuery({
    batchId: podDetails?.batchId
  });
  const podProductVariant = podProduct?.variants?.find(
    v => v.batchId === podDetails?.batchId
  );

  // Check if is first unlocked pod
  const { data: activatedPodHistoryData } = useActivatedPodHistory();
  const activatedPodHistory = activatedPodHistoryData?.content;
  const isFirstUnlockedPod = activatedPodHistory?.length <= 1;
  const showCtaLoading = activatedPodHistory === undefined;

  return (
    <ActivationLayout
      showLoading={!isUnlockAllowed || isLoadingPodProduct}
      fullHeight
    >
      <Box mb={{ xs: 2, md: 4 }}>
        <ActivationHeading>Voilà! Your pod is unlocked.</ActivationHeading>
      </Box>

      {/* Pod overview (Cover, title + brand, Oil stats table) */}
      <Box display="flex" flexDirection="column" mb={{ xs: 2, md: 4 }}>
        {/* Pod info card */}
        <PodProductCard
          productVariant={podProductVariant}
          podKey={podDetails?.podKey}
        />

        {/* Pod title & brand */}
        <Box textAlign="center" mt={{ xs: 1.5, md: 3 }}>
          <Typography variant="h5" component="span">
            {podProductVariant?.title}
          </Typography>
        </Box>

        {/* Oil stats table */}
        {podProductVariant && (
          <Box mt={{ xs: 1.5, md: 3 }}>
            <ProductDetailsOilTable productVariant={podProductVariant} />
          </Box>
        )}
      </Box>

      <Button
        variant="contained"
        color="primary"
        fullWidth
        disabled={showCtaLoading}
        component={Link}
        to={
          isFirstUnlockedPod
            ? `/us/en/unlock/${podKeyOrSerialNumber}/referral/`
            : "/us/en/shop"
        }
      >
        {showCtaLoading ? (
          <CircularProgress size={16} color="secondary" />
        ) : (
          "Continue"
        )}
      </Button>
    </ActivationLayout>
  );
}
